import { SpecialtyAttendanceModel } from "../../models/flow/specialty-attendance.model";

export class ManageSpecialtiesRequest {
    listSpecialtyAttendance: SpecialtyAttendanceModel[] = [];
    listSpecialtyDefault: SpecialtyAttendanceModel[] = [];
}